import Vue from "vue";
import VueI18n from "vue-i18n";
import es from "./messages/es";
import en from "./messages/en";

Vue.use(VueI18n);

export const SUPPORTED_LOCALES = ["es", "en"];
export const DEFAULT_LOCALE = "es";

const messages = {
  es,
  en,
};

const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  silentFallbackWarn: true,
});

export function normalizeLocale(rawLocale) {
  if (!rawLocale || typeof rawLocale !== "string") return null;
  const normalized = rawLocale.toLowerCase().trim();
  if (normalized.startsWith("es")) return "es";
  if (normalized.startsWith("en")) return "en";
  return null;
}

export function getBrowserLocale() {
  if (typeof window === "undefined") return null;
  const candidates = [
    ...(Array.isArray(window.navigator?.languages) ? window.navigator.languages : []),
    window.navigator?.language,
  ];
  for (const candidate of candidates) {
    const locale = normalizeLocale(candidate);
    if (locale) return locale;
  }
  return null;
}

export function setLocale(locale) {
  const resolved = normalizeLocale(locale) || DEFAULT_LOCALE;
  i18n.locale = resolved;
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", resolved);
  }
  return resolved;
}

export function getQueryLocale() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    return normalizeLocale(params.get("lang") || params.get("locale"));
  } catch (error) {
    return null;
  }
}

export function initializeLocale(savedUserLocale = null) {
  // Priority: ?lang= query > explicit user preference in Supabase > browser > default.
  const queryLocale = getQueryLocale();
  if (queryLocale) {
    return setLocale(queryLocale);
  }

  const savedLocale = normalizeLocale(savedUserLocale);
  if (savedLocale) {
    return setLocale(savedLocale);
  }
  const browserLocale = getBrowserLocale();
  if (browserLocale) {
    return setLocale(browserLocale);
  }

  return setLocale(DEFAULT_LOCALE);
}

export default i18n;
